module.exports = __webpack_public_path__ + "static/media/cloudscale.da769276.svg";